import {
  authenticate,
  getProfile,
  updateProfile,
  changePassword,
  resetPasswordRequest,
  resetPassword,
  verifyEmail,
  verifyOTPSMS,
  resendVerifyOTPSMS,
  sendVerifyEmail,
  createNewUser,
  newsletter,
  addAddress,
  deleteAddress,
  updateAddress,
  createGoogleLogin,
  createFBLogin,
  googleAuthenticate,
  fbAuthenticate,
} from '../services/users';
import { fetchPromoImage } from '../services/settings';

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE'
export const USER_GET_PROFILE_REQUEST = 'USER_GET_PROFILE_REQUEST'
export const USER_GET_PROFILE_SUCCESS = 'USER_GET_PROFILE_SUCCESS'
export const USER_GET_PROFILE_FAILURE = 'USER_GET_PROFILE_FAILURE'
export const USER_SAVE_PROFILE_REQUEST = 'USER_SAVE_PROFILE_REQUEST'
export const USER_SAVE_PROFILE_SUCCESS = 'USER_SAVE_PROFILE_SUCCESS'
export const USER_SAVE_PROFILE_FAILURE = 'USER_SAVE_PROFILE_FAILURE'
export const USER_CHANGE_PASSWORD_REQUEST = 'USER_CHANGE_PASSWORD_REQUEST'
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS'
export const USER_CHANGE_PASSWORD_FAILURE = 'USER_CHANGE_PASSWORD_FAILURE'
export const USER_RESET_DATA = 'USER_RESET_DATA';
export const SET_DELIVERY_PLACE = 'SET_DELIVERY_PLACE';

export const USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAILURE = 'USER_SIGNUP_FAILURE';

export const USER_GOOGLE_SIGNUP_REQUEST = 'USER_GOOGLE_SIGNUP_REQUEST';
export const USER_GOOGLE_SIGNUP_SUCCESS = 'USER_GOOGLE_SIGNUP_SUCCESS';
export const USER_GOOGLE_SIGNUP_FAILURE = 'USER_GOOGLE_SIGNUP_FAILURE';

export const USER_FB_SIGNUP_REQUEST = 'USER_FB_SIGNUP_REQUEST';
export const USER_FB_SIGNUP_SUCCESS = 'USER_FB_SIGNUP_SUCCESS';
export const USER_FB_SIGNUP_FAILURE = 'USER_FB_SIGNUP_FAILURE';

export const USER_NEWSLETTER_REQUEST = 'USER_NEWSLETTER_REQUEST';
export const USER_NEWSLETTER_SUCCESS = 'USER_NEWSLETTER_SUCCESS';
export const USER_NEWSLETTER_FAILURE = 'USER_SIGNUP_FAILURE';

export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST';
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS';
export const USER_RESET_PASSWORD_FAILURE = 'USER_RESET_PASSWORD_FAILURE';

export const USER_SET_NEW_PASSWORD_REQUEST = 'USER_SET_NEW_PASSWORD_REQUEST';
export const USER_SET_NEW_PASSWORD_SUCCESS = 'USER_SET_NEW_PASSWORD_SUCCESS';
export const USER_SET_NEW_PASSWORD_FAILURE = 'USER_SET_NEW_PASSWORD_FAILURE';

export const USER_VERIFY_EMAIL_REQUEST = 'USER_VERIFY_EMAIL_REQUEST';
export const USER_VERIFY_OTP_REQUEST = 'USER_VERIFY_OTP_REQUEST';
export const USER_VERIFY_EMAIL_SUCCESS = 'USER_VERIFY_EMAIL_SUCCESS';
export const USER_VERIFY_OTP_SUCCESS = 'USER_VERIFY_OTP_SUCCESS';
export const USER_VERIFY_EMAIL_FAILURE = 'USER_VERIFY_EMAIL_FAILURE';
export const USER_VERIFY_OTP_FAILURE = 'USER_VERIFY_OTP_FAILURE';

export const USER_SEND_VERIFY_EMAIL_REQUEST = 'USER_SEND_VERIFY_EMAIL_REQUEST';
export const USER_SEND_VERIFY_OTP_REQUEST = 'USER_SEND_VERIFY_OTP_REQUEST';
export const USER_SEND_VERIFY_EMAIL_SUCCESS = 'USER_SEND_VERIFY_EMAIL_SUCCESS';
export const USER_SEND_VERIFY_OTP_SUCCESS = 'USER_SEND_VERIFY_OTP_SUCCESS';
export const USER_SEND_VERIFY_EMAIL_FAILURE = 'USER_SEND_VERIFY_EMAIL_FAILURE';
export const USER_SEND_VERIFY_OTP_FAILURE = 'USER_SEND_VERIFY_OTP_FAILURE';

export const USER_ADD_ADDRESS_REQUEST = 'USER_ADD_ADDRESS_REQUEST';
export const USER_ADD_ADDRESS_SUCCESS = 'USER_ADD_ADDRESS_SUCCESS';
export const USER_ADD_ADDRESS_FAILURE = 'USER_ADD_ADDRESS_FAILURE';

export const USER_DELETE_ADDRESS_REQUEST = 'USER_DELETE_ADDRESS_REQUEST';
export const USER_DELETE_ADDRESS_SUCCESS = 'USER_DELETE_ADDRESS_SUCCESS';
export const USER_DELETE_ADDRESS_FAILURE = 'USER_DELETE_ADDRESS_FAILURE';

export const USER_UPDATE_ADDRESS_REQUEST = 'USER_UPDATE_ADDRESS_REQUEST';
export const USER_UPDATE_ADDRESS_SUCCESS = 'USER_UPDATE_ADDRESS_SUCCESS';
export const USER_UPDATE_ADDRESS_FAILURE = 'USER_UPDATE_ADDRESS_FAILURE';

export const PROMO_IMAGE_REQUEST = 'PROMO_IMAGE_REQUEST';
export const PROMO_IMAGE_SUCCESS = 'PROMO_IMAGE_SUCCESS';
export const PROMO_IMAGE_FAILURE = 'PROMO_IMAGE_FAILURE';

export function login(data, callback) {
  return dispatch => {
    dispatch({type: USER_LOGIN_REQUEST})
    return authenticate(data).then(res => {
      dispatch({type: USER_LOGIN_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_LOGIN_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}


export function googlelogin(data, callback) {
  
  return dispatch => {
    dispatch({type: USER_LOGIN_REQUEST})
    return googleAuthenticate(data).then(res => {
      dispatch({type: USER_LOGIN_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_LOGIN_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}


export function fblogin(data, callback) {
  
  return dispatch => {
    dispatch({type: USER_LOGIN_REQUEST})
    return fbAuthenticate(data).then(res => {
      dispatch({type: USER_LOGIN_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_LOGIN_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function getProfileDetails(callback) {
  return dispatch => {
    dispatch({type: USER_GET_PROFILE_REQUEST})
    return getProfile().then(res => {
      dispatch({type: USER_GET_PROFILE_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_GET_PROFILE_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function saveProfileDetails(data, callback) {
  return dispatch => {
    dispatch({type: USER_SAVE_PROFILE_REQUEST})
    return updateProfile(data).then(res => {
      dispatch({type: USER_SAVE_PROFILE_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_SAVE_PROFILE_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function changePasswordRequest(data, callback) {
  return dispatch => {
    dispatch({type: USER_CHANGE_PASSWORD_REQUEST})
    return changePassword(data).then(res => {
      dispatch({type: USER_CHANGE_PASSWORD_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_CHANGE_PASSWORD_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function requestResetPassword(data, callback) {
  return dispatch => {
    dispatch({type: USER_RESET_PASSWORD_REQUEST})
    return resetPasswordRequest(data).then(res => {
      dispatch({type: USER_RESET_PASSWORD_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_RESET_PASSWORD_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function setNewPassword(data, callback) {
  return dispatch => {
    dispatch({type: USER_SET_NEW_PASSWORD_REQUEST})
    return resetPassword(data).then(res => {
      dispatch({type: USER_SET_NEW_PASSWORD_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_SET_NEW_PASSWORD_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function setVerifyEmail(data, callback) {
  return dispatch => {
    dispatch({type: USER_VERIFY_EMAIL_REQUEST})
    return verifyEmail(data).then(res => {
      dispatch({type: USER_VERIFY_EMAIL_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_VERIFY_EMAIL_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}
export function setVerifyOTP(data, callback) {
  return dispatch => {
    dispatch({type: USER_VERIFY_OTP_REQUEST})
    return verifyOTPSMS(data).then(res => {
      dispatch({type: USER_VERIFY_OTP_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_VERIFY_OTP_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function resendVerifyOTP(data, callback) {
  return dispatch => {
    dispatch({type: USER_SEND_VERIFY_OTP_REQUEST})
    return resendVerifyOTPSMS(data).then(res => {
      dispatch({type: USER_SEND_VERIFY_OTP_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_SEND_VERIFY_OTP_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function resendVerifyEmail(data, callback) {
  return dispatch => {
    dispatch({type: USER_SEND_VERIFY_EMAIL_REQUEST})
    return sendVerifyEmail(data).then(res => {
      dispatch({type: USER_SEND_VERIFY_EMAIL_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_SEND_VERIFY_EMAIL_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function resetUserData() {
  return {type: USER_RESET_DATA}
}

export function signup(data, callback) {
  return dispatch => {
    dispatch({type: USER_SIGNUP_REQUEST})
    return createNewUser(data).then(res => {
      dispatch({type: USER_SIGNUP_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_SIGNUP_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function Googlesignup(data, callback) {
  return dispatch => {
    dispatch({type: USER_GOOGLE_SIGNUP_REQUEST})
    return createGoogleLogin(data).then(res => {
      dispatch({type: USER_GOOGLE_SIGNUP_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_GOOGLE_SIGNUP_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function FBsignup(data, callback) {
  return dispatch => {
    dispatch({type: USER_FB_SIGNUP_REQUEST})
    return createFBLogin(data).then(res => {
      dispatch({type: USER_FB_SIGNUP_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_FB_SIGNUP_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function subscribeNews(data, callback) {
  return dispatch => {
    dispatch({type: USER_NEWSLETTER_REQUEST})
    return newsletter(data).then(res => {
      dispatch({type: USER_NEWSLETTER_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_NEWSLETTER_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function addUserAddress(data, callback) {
  return dispatch => {
    dispatch({type: USER_ADD_ADDRESS_REQUEST})
    return addAddress(data).then(res => {
      dispatch({type: USER_ADD_ADDRESS_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_ADD_ADDRESS_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function deleteUserAddress(data, callback) {
  return dispatch => {
    dispatch({type: USER_DELETE_ADDRESS_REQUEST})
    return deleteAddress(data).then(res => {
      dispatch({type: USER_DELETE_ADDRESS_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_DELETE_ADDRESS_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}

export function updateUserAddress(data, callback) {
  return dispatch => {
    dispatch({type: USER_UPDATE_ADDRESS_REQUEST})
    return updateAddress(data).then(res => {
      dispatch({type: USER_UPDATE_ADDRESS_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(error => {
      dispatch({type: USER_UPDATE_ADDRESS_FAILURE, payload: error.error})
      if (callback) {
        callback({status: false, data: error.error})
      }
    });
  };
}


export function setDeliveryPlace(data) {
  return {
    type: SET_DELIVERY_PLACE,
    payload: data
  }
}

export function promoImage(callback) {
  return dispatch => {
    dispatch({ type: PROMO_IMAGE_REQUEST })
    return fetchPromoImage().then(res => {
      dispatch({ type: PROMO_IMAGE_SUCCESS, payload: res })
      if (callback) {
        callback({ status: true, data: res })
        console.log(res,"inside")
      }
    }).catch(error => {
      dispatch({ type: PROMO_IMAGE_FAILURE, payload: error.error })
      if (callback) {
        callback({ status: false, data: error.error })
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/userActions.js